<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <div class="mb-10">
      <div class="d-flex align-items-center justify-content-center mt-5 mb-3">
        <BaseIcon size="small">
          <PixelIcon />
        </BaseIcon>
        <h1 class="text-uppercase my-0 ms-5">{{ $t('pixels') }}</h1>
      </div>
      <p class="font-size-small mb-0 text-center" v-html="$t('info_about_pixels')"></p>
    </div>
    <div class="d-flex align-items-center justify-content-between">
      <div class="col-7 pb-5">
        <h5 class="">{{ $t('insertion_instructions_via_GTM_or_wix') }}</h5>
        <p class="font-size-xSmall mb-0">{{ $t('info_instructions_via_GTM_or_wix') }} <a href="https://pixelroads.com.br/blog/como-instalar-um-pixel-com-gtm-google-tag-manager-usando-floodlight-codigos" target="_blank">{{ $t('click_here') }}</a> {{ $t('info_instructions_via_GTM_or_wix2') }}</p>
      </div>
      <Button
        class="btn-color9"
        @click.prevent="openNewPixel"
      >
        {{ $t('new_pixel') }}
      </Button>
    </div>
    <!-- PIXELS -->
    <div class="mt-4">
      <div v-if="loader && localPixels.length === 0" class="text-center">
        <Loader
          :size="'big'"
        />
      </div>
      <template v-else>
        <UpsertPixel
          v-if="openUpsertPixel"
          :pixel="selectedPixel"
          @pixel-updated="getPixels"
          @pixel-created="getPixels"
        />
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <div class="d-flex justify-content-between p-6 pe-0 border-bottom border-dashed w-1500 text-color11 fw-600">
                <div class="ms-10"></div>
                <div class="col-4">{{ $t('advertiser') }}</div>
                <div class="col-4">{{ $t('pixel_name') }}</div>
                <div class="col-2">{{ $t('creation_date') }}</div>
                <div class="me-5"></div>
              </div>
              <div class="accordion accordion-flush w-1500" id="accordionPixels" >
                <div class="accordion-item border-bottom border-dashed" v-for="(pixel, index) in localPixels" :key="index">
                  <h2 class="accordion-header d-flex align-items-center">
                    <button class="accordion-button collapsed pe-0" type="button" data-bs-toggle="collapse" :data-bs-target="'#flush-collapse' + index" aria-expanded="false" :aria-controls="'flush-collapse' + index">
                      <div class="d-flex justify-content-between align-items-center w-100">
                        <div class=""></div>
                        <div class="col-4">
                          <router-link :to="{ name: 'advertisers.show', params: { id: pixel.advertiser.id } }">
                            {{ pixel.advertiser.name }}
                          </router-link>
                        </div>
                        <div class="col-4">{{ pixel.name }}</div>
                        <div class="col-2">{{ pixel.created_at | formatDate }}</div>
                      </div>
                    </button>
                    <div class="px-5 py-5 border-dashed border-start">
                      <a href="#" @click.prevent="openEditPixel(pixel)" v-b-tooltip.hover :title="$t('edit')">
                        <i class="fa fa-pencil font-size-small text-color11"></i>
                      </a>
                    </div>
                  </h2>
                  <div :id="'flush-collapse' + index " class="accordion-collapse collapse" data-bs-parent="#accordionPixels">
                    <div class="accordion-body">
                      <h4 class="mb-5" v-if="pixel.rules.some(rule => rule.google_id)">{{ $t('rules') }}</h4>
                      <div class="d-flex flex-wrap justify-content-center gap-5">
                        <div v-for="(rule, index) in pixel.rules" :key="index">
                          <!-- GOOGLE -->
                          <div>
                            <div class="border border-gray-300 border-dashed p-5">
                              <div class="mb-1">
                                <label class="fw-semibold text-muted me-2">{{ $t('rule_name') }}: </label>
                                <span class="fw-bold text-gray-800">{{ rule.name }}</span>
                              </div>
                              <div class="mb-1">
                                <label class="fw-semibold text-muted me-2">{{ $t('objective') }}:</label>
                                <span class="badge badge-light fw-bold p-3">{{ rule.objective | formatObjective }}</span>
                              </div>
                              <div class="mb-1">
                                <label class="fw-semibold text-muted me-2">{{ $t('event_name') }}:</label>
                                {{ rule.event_name }}
                              </div>
                              <div class="mb-2">
                                <label class="fw-semibold text-muted me-2">{{ $t('status') }}:</label>
                                <CampaignStatusBadge :status="rule.status"/>
                              </div>
                              <div class="mb-0">
                                <label class="fw-semibold text-muted mb-1">{{ $t('pixel_code') }}</label><br/>
                                <div class="mt-1" v-if="rule.google_id">
                                  <strong class="text-gray-800">Floodlight ID:</strong> <span>{{ pixel.google_id }}</span><br/>
                                  <strong class="text-gray-800">Activity Group Tag String:</strong> invmedia<br/>
                                  <strong class="text-gray-800">Activity Tag String:</strong> {{ rule.google_activity_tag }}
                                </div>
                                <div class="mt-2" v-else>
                                  <p class="text-warning p-0 m-0">{{ $t('pixel_creation_can_take_up_to_48_hours') }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- END GOOGLE -->
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="localPixels.length == 0 && !loader">
              <p class="text-center fw-semibold text-gray-700 mt-20">{{ $t('no_pixels_found') }}</p>
            </div>
            <!--begin::Pagination-->
            <div class="d-flex flex-stack flex-wrap pt-10 ms-6 pb-1" v-if="localPixels.length > 0">
              <div class="fs-6 fw-semibold text-gray-700">
                {{ $t('pagination', { from: from, to: to, totalItems: totalItems }) }}
              </div>
              <!--begin::Pages-->
              <b-pagination
                class="custom-pagination"
                v-if="totalPages > 1"
                v-model="page"
                :total-rows="totalItems"
                :per-page="itemsPerPage"
                :loading="usersLoader"
                @input="getPixels"
                hide-goto-end-buttons
              />
              <!--end::Pages-->
            </div>
            <!--end::Pagination-->
          </div>
        </div>
      </template>
    </div>
    <!-- END PIXELS -->
  </MainLayout>
</template>

<script>

import { mapState } from 'vuex'
import PixelsService from '@/modules/pixels/services/pixels-service'

import BaseIcon from '@/components/common/Icon/BaseIcon'
import Button from '@/components/common/Button/Button'
import CampaignStatusBadge from '@/components/common/Badge/CampaignStatusBadge'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'
import PixelIcon from '@/components/common/Icon/PixelIcon'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'
import UpsertPixel from '@/components/pixels/UpsertPixelForm'

export default {
  components: {
    BaseIcon,
    Button,
    CampaignStatusBadge,
    Loader,
    MainLayout,
    PixelIcon,
    Shortcuts,
    UpsertPixel
  },
  data () {
    return {
      advertiser: null,
      from: 1,
      itemsPerPage: 0,
      localPixels: [],
      loader: false,
      openUpsertPixel: false,
      page: 1,
      to: 9,
      totalItems: 0,
      totalPages: 0,
      reload: false,
      selectedPixel: null
    }
  },
  metaInfo () {
    return {
      title: this.$t('pixels')
    }
  },
  created () {
    this.getPixels()
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    /**
     * Get campaigns
     */
    async getPixels () {
      this.openUpsertPixel = false
      this.loader = true
      try {
        this.localPixels = []
        const pixels = await PixelsService.getPixels({
          // advertiserId: this.advertiserId,
          page: this.page
        })
        this.localPixels = pixels.data
        this.totalItems = pixels.meta.total
        this.totalPages = pixels.meta.last_page
        this.itemsPerPage = pixels.meta.per_page
        this.from = pixels.meta.from
        this.to = pixels.meta.to
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * Reset and reload
     */
    reset () {
      this.page = 1
      this.localPixels = []
      this.getPixels()
    },
    /**
     * Open to edit pixel
     */
    openEditPixel (pixel) {
      this.selectedPixel = pixel
      this.openUpsertPixel = true
    },
    /**
     * Open  to create pixel
     */
    openNewPixel () {
      this.selectedPixel = null
      this.openUpsertPixel = true
    }
  }
}
</script>

<style lang="scss" scoped>
a.pending {
  opacity: 0.5;
}

.accordion-button {
  flex-direction: row-reverse;
  background-color: transparent;
}

.w-1500 {
  width: 1300px;

  @include desktop-lg {
    width: auto;
  }
}

.btn-copy {
  padding: 0 8px !important;
}
</style>
